<footer class="m-grid__item m-footer mini-footer text-center m-footer__wrapper mt-3">
    <p class="mf-accent-color m--visible-desktop">v{{ version }}</p>
</footer>
